module.exports = __webpack_public_path__ + "static/media/bmw.6410a2b6.png";